import {connect, useSelector} from 'react-redux';
import {push} from 'connected-react-router'
import {additionalCollectorQuestionSelect} from '../../redux/selector/additionalCollectorQuestionSelector'
import {setAdditionalCollectorQuestionAnswer} from '../../redux/slice/additionalCollectorQuestionSlice'
import {
    Header, 
    Paragraph, 
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import {replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';
import { 
    APPLICATION_MODE_RENEW,
    APPLICATION_STATUS_PENDING_PAYMENT,
    APPLICATION_TYPE_COLLECTION_AGENCY, 
    APPLICATION_TYPE_COLLECTOR, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT, 
    LICENCE_STATUS_NEW,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
    ROUTE_PATH
} from '../../app/constants';

const AdditionalCollectorQuestion = (props) => {
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const additionalCollectorQuestion = props.additionalCollectorQuestion[applicationType] ? 
            props.additionalCollectorQuestion[applicationType] : props.additionalCollectorQuestion
    const {primaryAgencyApplication} = useSelector((state) => ({
        primaryAgencyApplication : state.primaryAgencyApplication.application
    }))
    const isDraftRenewalApplication = () => (
        (primaryAgencyApplication?.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
            || primaryAgencyApplication?.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL)
            && primaryAgencyApplication?.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
            && primaryAgencyApplication?.licenceStatus === LICENCE_STATUS_NEW);

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />
                <div className="row">
                    <div className="col-lg-8">
                        <Header header={additionalCollectorQuestion.header} />
                        <Paragraph text={additionalCollectorQuestion.text} />
                        <div className="row">
                            <div className="col-auto">
                                <Button 
                                    id="additional-collector-question-yes"
                                    className="ns-btn-yes-no btn-default"
                                    text={"Yes"}
                                    buttonType={"regular_primary"}
                                    onClick={() => {
                                        dispatch(setAdditionalCollectorQuestionAnswer("yes"))
                                        let appType = APPLICATION_TYPE_COLLECTOR
                                        if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                                            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT)
                                            appType = APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT
                                        dispatch(push(replaceUrlParams(additionalCollectorQuestion.navigation.yes,appType, applicationMode)))
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <Button 
                                    id="additional-collector-question-no"
                                    className="ns-btn-yes-no btn-default"
                                    text={"No"}
                                    buttonType={"regular_primary"}
                                    onClick={() => {
                                        let appType = APPLICATION_TYPE_COLLECTION_AGENCY

                                        if(applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT 
                                            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
                                            appType = APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                                        }

                                        dispatch(setAdditionalCollectorQuestionAnswer("no"))
                                        let nextPath = replaceUrlParams(additionalCollectorQuestion.navigation.no,appType, applicationMode);

                                        if(isDraftRenewalApplication()) {
                                            nextPath = replaceUrlParams(ROUTE_PATH.COLLECTORS_REVIEW,appType, APPLICATION_MODE_RENEW);
                                        }

                                        dispatch(push(nextPath))
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default connect(additionalCollectorQuestionSelect)(AdditionalCollectorQuestion)
